import { render } from "./IframeRenderer.vue?vue&type=template&id=28970c9e&scoped=true"
import script from "./IframeRenderer.vue?vue&type=script&lang=js"
export * from "./IframeRenderer.vue?vue&type=script&lang=js"

import "./IframeRenderer.vue?vue&type=style&index=0&id=28970c9e&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28970c9e"]])

export default __exports__